// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"74612715","453":"f85b8550"}[chunkId] + ".chunk.js";
};